import { carrierUtils, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
export const isDeltaAirlinesOffer = (flight) => carrierUtils.hasMarketingCarrier(flight.segments, ["DL"]);
export const shouldPreopenBrandedFares = (flight) => isFeatureRunningClientSide("FLIGHTS_PRE_OPEN_BRANDED_FARES_DELTA") && isDeltaAirlinesOffer(flight);
